import AppConfig from '../appConfig'

class ProfileFetch {
    static getProfile(idOrg) {
        const url = AppConfig.apiUrl+"/entity/"+idOrg;

        return fetch(url, {
            method: 'GET'
        }).then((response => {
            return response.json()
        }));
    }

    static getFundings(idOrg) {
        const url = AppConfig.apiUrl+"/entity/"+idOrg+"/fundings";

        return fetch(url, {
            method: 'GET'
        }).then((response => {
            return response.json()
        }));
    }

    static getInvestments(idOrg) {
        const url = AppConfig.apiUrl+"/entity/"+idOrg+"/investments";

        return fetch(url, {
            method: 'GET'
        }).then((response => {
            return response.json()
        }));
    }

    static getRoundValues() {
        const url = AppConfig.apiUrl+"/round_values";

        return fetch(url, {
            method: 'GET'
        }).then((response => {
            return response.json()
        }));
    }

    static searchEntity(searchTerm, entityType) {
        const url = AppConfig.apiUrl+"/entity/search";

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'searchTerm': searchTerm,
                'entityType': entityType,
            })
        }).then((response => {
            return response.json()
        }));
    }

    static updateEntity(entityInfo, skipValidation) {
        const url = AppConfig.apiUrl+"/entity";

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'entity_info': entityInfo,
                'skip_validation': skipValidation
            })
        }).then((response => {
            return response.json()
        }));
    }

    static updateFunding(idCbiEntity, idEntityDraft, fundingInfo, idFundingsToDelete, returnFundings, source) {
        const url = AppConfig.apiUrl+"/funding";

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                "idCbiEntity": idCbiEntity,
                "idEntityDraft": idEntityDraft,
                "fundingInfo": fundingInfo,
                "idFundingsToDelete": idFundingsToDelete,
                "returnFundings": returnFundings,
                "source": source
            })
        }).then((response => {
            return response.json()
        }));
    }

    static addFundingNote(idCbiEntity, idEntityDraft, note) {
        const url = AppConfig.apiUrl+"/entity/funding/note";

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                "id_cbi_entity": idCbiEntity,
                "id_entity_draft": idEntityDraft,
                "note": note
            })
        }).then((response => {
            return response.json()
        }));
    }

    static recordEvent(event, orgId) {
        const url = AppConfig.apiUrl+"/event/record";

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                orgId: orgId,
                event: event
            })
        }).then((response => {
            return response.json()
        }));
    }
}

export default ProfileFetch;